export default "__VITE_ASSET__D81_ObT6__"